module.exports = __webpack_public_path__ + "img/video_icon.90f5f4bb.gif";